<template>
  <div v-if="spaces.length > 0" id="appLauncherCollection">
    <grid-card
      v-for="card in spaces"
      @click="goToAppLauncher(card.id)"
      @click:ctrl="goToAppLauncher(card.id)"
      :key="card.id"
      :workspace="card"
      prevent-navigation
    />
  </div>

  <p v-else :class="['app-launcher-collection', 'app-launcher-collection--empty']">
    {{ t("noSpaces") }}
  </p>
</template>

<script lang="ts">
import { defineComponent, computed } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import { notifyCustomMessage } from "@/views/appLauncher/lib/webview-communication"
import { useStore } from "@/composable/useStore"
import Loader from "@/utils/loader"
import GridCard from "../workspaceList/components/gridView/GridCard.vue"
import Router, { navigate } from "@/router"
import "./appLauncherCollection.scss"

export default defineComponent({
  name: "AppLauncherCollection",
  setup() {
    const { spaceModule } = useStore()
    const loader = Loader()
    const t = createTranslationModule("AppLauncherCollection")

    const spaces = computed(() => {
      return spaceModule.myWorkspaces
    })

    const goToAppLauncher = (workspaceId: string) => {
      navigate({ name: "AppLauncher", params: { workspaceId } })
    }

    const goToAppLauncherNewTab = (workspaceId: string) => {
      const space = spaces.value.find(_space => _space.id === workspaceId)

      if (space) {
        const appId = space.schema.assets.slice(-1)[0]?.id

        if (appId) {
          const routeData = Router.resolve({
            name: "AppLauncher",
            params: { workspaceId, appId }
          })

          window.open(routeData.href, "_blank")
        }
      }
    }

    const _redirectIfNoSpaceVariety = () => {
      if (spaceModule.myWorkspaces.length === 1) {
        const space = spaceModule.myWorkspaces[0]

        if (space?.id) {
          navigate({
            name: "AppLauncher",
            params: { workspaceId: space.id }
          })
        }
      }
    }

    const _notifySpaceCountToAppLauncher = () => {
      notifyCustomMessage({
        variant: "space-count",
        message: {
          spaces: spaces.value.length
        }
      })
    }

    loader.run(async () => {
      await spaceModule.getMyWorkspaces()
      _notifySpaceCountToAppLauncher()
      _redirectIfNoSpaceVariety()
    })

    return {
      t,
      goToAppLauncherNewTab,
      goToAppLauncher,
      spaces,
      loader
    }
  },
  components: {
    GridCard
  }
})
</script>
